// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8081) return "static/chunks/8081-316b05ff1212a10c.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"4106":"b9633c63","9486":"cdcd3b9e"}[chunkId] || chunkId) + "." + {"4106":"60420a8ad16cdc9a","4629":"846ffc9e49e9ea40","6823":"d37b0bfe2c485f68","7496":"cf0799274c20d172","8532":"b35e4bbd63cb183a","8950":"eef002c9f6cdf536","9486":"45df373f2b3627e0"}[chunkId] + ".js";
};